/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const userDataRole = {
	member: 'member',
	admin: 'admin',
	jobillan: 'jobillan',
	recruiter: 'recruiter',
} as const

export type UserDataRole = (typeof userDataRole)[keyof typeof userDataRole]
